var e={exports:{}};export{e as __module};
//# sourceMappingURL=customParseFormat.js.map
